import { createContext, useContext, useState, useEffect } from "react";
import api from "../api/api";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true); // track if restoring

  useEffect(() => {
    const token = localStorage.getItem("token");
    const storedUser = localStorage.getItem("user");
    if (token && storedUser) {
      setUser(JSON.parse(storedUser));

      // Attach token to axios instance
      api.defaults.headers.common["Authorization"] = `Bearer ${token}`;

      // refreshUser();
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    try {
      const { data } = await api.post("/login", { email, password });
      localStorage.setItem("token", data.token);
      localStorage.setItem("user", JSON.stringify(data.user));
      setUser(data.user);
      console.log(data);

      // Attach token for future requests
      api.defaults.headers.common["Authorization"] = `Bearer ${data.token}`;
    } catch (err) {
      console.error("Login failed:", err);
      if (err.response?.data?.message) {
        throw new Error(err.response.data.message);
      } else {
        throw new Error("Login failed. Please try again.");
      }
    }
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    delete api.defaults.headers.common["Authorization"];
  };

  // const refreshUser = async () => {
  //   try {
  //     const token = localStorage.getItem("token");
  //     const storedUser = localStorage.getItem("user");
  //     if (token && storedUser) {
  //       const userId = JSON.parse(storedUser).user_id;
  //       const { data } = await api.get(`/user-details/${userId}`, {
  //         headers: { Authorization: `Bearer ${token}` },
  //       });
  //       setUser(data.user);
  //       localStorage.setItem("user", JSON.stringify(data.user));
  //     }
  //   } catch (error) {
  //     console.error("Failed to refresh user:", error);
  //   }
  // };

  // Wait for loading to finish before rendering children
  if (loading) return <div>Loading...</div>;

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
